import { combineReducers } from "redux";
import profile from "./profile";
import settings from "./settings";
import messages from "./messagesRed";
import pdfMessages from "./pdfMessagesRed";

const reducerApp = combineReducers({
  profile,
  messages,
  pdfMessages,
  settings,
});

export default reducerApp;
